import React from 'react'
import TableHeader from '../../Shared/TableHeader'
import { Col, Row } from 'react-bootstrap'
import ChatList from './ChatList'
import SummaryFilters from './SummaryFilters'

const ChatSummary = () => {
    return (
        <>
        {/* <TableHeader headerValue={"Chat Summary"}/> */}
            <Row>
                {/* <Col classCame="chat-main-left" xs={3} style={{ backgroundColor: '#fff' }}>
                   <SummaryFilters/>
                </Col> */}
                <Col className="slide-chatbox" xs={12}>
                    <ChatList/>
                </Col>
            </Row>
        </>
    )
}

export default ChatSummary